export const RAINBOW = [
  `#ff0000`,
  `#ff7f00`,
  `#ffff00`,
  `#00ff00`,
  `#0000ff`,
  `#4b0082`,
  `#9400d3`,
]

const wrapAround = (value: number, [min, max]: [min: number, max: number]) =>
  ((((value - min) % (max - min)) + (max - min)) % (max - min)) + min

export const wrapInto = <T>(idx: number, array: ReadonlyArray<T>): T =>
  array[wrapAround(idx, [0, array.length])]

export const getRainbow = (idx: number): string => wrapInto(idx, RAINBOW)
